import React from 'react';
import {withRouter} from "react-router-dom";
import {FormGroup} from "reactstrap";
import ListOfText from "../common/ListOfText";

const DateSelect = (props) => {
  const {field, fieldNumber} = props

  let dateSelected = new Date(field.value+'Z')

  return <>
    <FormGroup row>
      <ListOfText field={{...field,value:dateSelected.toLocaleDateString()}} fieldNumber={fieldNumber} />
    </FormGroup>
  </>
}

export default withRouter(DateSelect);
